import { useState } from "react"
import { useAtomValue } from "jotai"
import { Link } from "@tanstack/react-router"
import { useAutoFocus } from "@mylaunch/components/hooks"
import { InputMask } from "@react-input/mask"
import { loginDialogAtom } from "../atoms/login"
import { SendOtpButton } from "./send-otp-button"

export function LoginStep1() {
  const state = useAtomValue(loginDialogAtom)
  const [phone, setPhone] = useState(state.phone)
  const inputRef = useAutoFocus<HTMLInputElement>()

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    const digits = value.replace(/\D/g, "")
    // If user enters 8 as first digit, convert to +7
    setPhone(digits === "78" ? "+7" : value)
  }

  const isValid = phone.length >= 18

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-center">Войти в аккаунт</h2>
      <InputMask
        type="tel"
        mask="+7 (___) ___-__-__"
        replacement={{ _: /\d/ }}
        value={phone}
        onChange={handlePhoneChange}
        className="w-full p-3 border border-light-grey rounded-m text-base outline-none rounded-md"
        ref={inputRef}
        placeholder="+7 (XXX) XXX-XX-XX"
      />
      <SendOtpButton phone={phone} disabled={!isValid} size="lg">
        Отправить код
      </SendOtpButton>
      <p className="text-center text-sm text-muted-foreground">
        Входя в аккаунт, вы соглашаетесь с обработкой персональных данных в соответствии с{" "}
        <Link to="/profile/privacy-policy" className="text-secondary no-underline">
          Политикой конфиденциальности
        </Link>
        .
      </p>
    </div>
  )
}
